'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.tpFirmwares.add', [])
  .controller('TpFirmwaresAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tpFirmwares/add/index.js